import React, { useMemo } from 'react';
import OutputViewerSection from '../OutputViewerSection';
import removeUnderscoreMetaFromResponse from './removeUnderscoreMetaFromResponse';

const ResponseSection = ({ data, collapseAmount = 3 }) => {
  // Memoize the cleaned data to prevent unnecessary processing
  const cleanedData = useMemo(() => removeUnderscoreMetaFromResponse(data), [data]);

  return (
    <OutputViewerSection className={'py-2'}>
      <OutputViewerSection.CodeBlock code={cleanedData} collapsed={collapseAmount} />
    </OutputViewerSection>
  );
};

export default ResponseSection;
